window.jscIsPreorderOverLimitFromEl = function(el) {
  if (!el) return false;
  var $el = $(el);
  if ($el.attr('data-preorder-enable') !== 'true') return false;
  if ($el.attr('data-preorder-over-limit') === 'true') return true;
  var limitRaw = $el.attr('data-preorder-limit');
  var invRaw = $el.attr('data-preorder-inventory');
  if (limitRaw === undefined || limitRaw === null || limitRaw === '' ||
      invRaw === undefined || invRaw === null || invRaw === '') {
    return false;
  }
  var limit = parseInt(String(limitRaw).trim(), 10);
  var inv = parseInt(String(invRaw).trim(), 10);
  if (isNaN(limit) || isNaN(inv)) return false;
  return inv <= limit;
};

window.jscGetAtcLabel = function(variantId) {
  var $vd = $('.variant-list-data[data-var-id="' + variantId + '"]').first();
  if ($vd.length && window.jscIsPreorderOverLimitFromEl($vd)) {
    return 'Sold Out';
  }
  if ($vd.length && $vd.attr('data-preorder-enable') === 'true') {
    return 'Pre-Order';
  }
  return 'Add To Bag';
};

window.jscApplyPreorderUI = function(variantId, $scope) {
  var $root = $scope && $scope.length ? $scope : $(document);
  var $vd = $root.find('.variant-list-data[data-var-id="' + variantId + '"]').first();
  if (!$vd.length) {
    $vd = $('.variant-list-data[data-var-id="' + variantId + '"]').first();
  }
  var isPreorder = !!( $vd.length && $vd.attr('data-preorder-enable') === 'true' );
  var isOverLimit = window.jscIsPreorderOverLimitFromEl($vd);
  var shipDate = isPreorder ? ($vd.attr('data-preorder-ship-date') || '') : '';
  var canPurchase = $vd.attr('data-var-avail') === 'true' && $vd.attr('showcomingsoonwheninstock') !== 'true';
  var isVipVariant = $vd.attr('data-vip') === 'true';
  var isVipCustomer = $('#vipCustomer').length >= 1;
  if (isVipVariant && !isVipCustomer) {
    canPurchase = false;
  }
  if (isOverLimit) {
    canPurchase = false;
  }

  var $notices = $root.find('.jsc-preorder-notice');
  if (!$notices.length) {
    $notices = $('.jsc-preorder-notice');
  }
  var $limitNotices = $root.find('.jsc-preorder-limit-notice');
  if (!$limitNotices.length) {
    $limitNotices = $('.jsc-preorder-limit-notice');
  }

  var $btns = $root.find('.single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)');
  var $stickyBtn = $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)');
  var $buyNow = $root.find('.jsc-buy-it-now-button');
  var $qty = $root.find('quantity-selector, .quantity');
  var $bisPdp = $root.find('.swym-bid-pdp');
  var $bisQv = $root.find('.swym-bid-qv');
  if (!$bisPdp.length) $bisPdp = $('.swym-bid-pdp');
  if (!$bisQv.length) $bisQv = $('.product-form-qv .swym-bid-qv, .swym-bid-qv');

  if (isOverLimit) {
    $notices.hide();
    $limitNotices.show();
    var soldOutLabel = 'Sold Out';
    $btns.each(function() {
      var $btn = $(this);
      var $text = $btn.find('.single-add-to-cart-button--text');
      $btn.removeClass('jsc-preorder-atc').addClass('sold-out jsc-sold-out-styling').attr('disabled', true).show();
      if ($text.length) $text.text(soldOutLabel);
      else $btn.text(soldOutLabel);
    });
    $stickyBtn.removeClass('jsc-preorder-atc').addClass('sold-out jsc-sold-out-styling').attr('disabled', true).show();
    var $stickyText = $stickyBtn.find('.single-add-to-cart-button--text');
    if ($stickyText.length) $stickyText.text(soldOutLabel);
    $buyNow.attr('disabled', true).hide();
    $root.find('.shopify-payment-button').hide();
    $('.product-add-to-cart-sticky--content .shopify-payment-button').hide();
    $qty.find('input, button').attr('disabled', true);
    if ($bisPdp.length) $bisPdp.hide();
    if ($bisQv.length) $bisQv.hide();
    return;
  }

  $limitNotices.hide();
  $qty.find('input, button').removeAttr('disabled');

  if (isPreorder && canPurchase) {
    $notices.find('.jsc-preorder-ship-date').text(shipDate);
    $notices.show();
    var label = 'Pre-Order';
    $btns.each(function() {
      var $btn = $(this);
      $btn.addClass('jsc-preorder-atc').show();
      if (!$btn.attr('disabled') && !$btn.hasClass('jsc-sold-out-styling') && !$btn.hasClass('sold-out')) {
        var $text = $btn.find('.single-add-to-cart-button--text');
        if ($text.length) {
          $text.text(label);
        } else {
          $btn.text(label);
        }
      }
    });
    $stickyBtn.addClass('jsc-preorder-atc').show();
    var $stickyText = $stickyBtn.find('.single-add-to-cart-button--text');
    if ($stickyBtn.length && !$stickyBtn.attr('disabled') && !$stickyBtn.hasClass('jsc-sold-out-styling') && !$stickyBtn.hasClass('sold-out')) {
      $stickyText.text(label);
    }
    if ($vd.attr('data-var-avail') === 'true') {
      if ($bisPdp.length) $bisPdp.hide();
      if ($bisQv.length) $bisQv.hide();
    }
  } else {
    $notices.hide();
    $btns.removeClass('jsc-preorder-atc');
    $stickyBtn.removeClass('jsc-preorder-atc');
  }
};

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();

      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
      // Swym code starts here
  document.dispatchEvent(new CustomEvent("swym:variant-change", {detail:this.currentVariant.id}));
  // Swym code ends here
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          const checkedInput = fieldset.querySelector('input:checked');
          if (!checkedInput) return;
          this.options.push(checkedInput.value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        const selectedValue = this.options[i];
        if (item.classList.contains('product-form__input--color-categorized')) {
          const checkedInput = item.querySelector('input:checked');
          const activeCategory = checkedInput
            ? checkedInput.closest('.product-form__color-category')
            : null;
          const activeCategoryName = activeCategory
            ? activeCategory.getAttribute('data-color-category')
            : null;
          item.querySelectorAll('.product-form__color-category').forEach((categoryEl) => {
            const label = categoryEl.querySelector('.form__label__value');
            if (!label) return;
            if (categoryEl.getAttribute('data-color-category') === activeCategoryName) {
              label.innerHTML = selectedValue;
            } else {
              label.innerHTML = '';
            }
          });
          return;
        }
        let labels = item.querySelectorAll('.form__label__value');
        labels.forEach((label) => {
          label.innerHTML = selectedValue;
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      //edit by Jumpstart
      /*
      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
      */
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    updateVariantAddToCartState() {
      if (!this.currentVariant) return;
      var currentvarID = this.currentVariant.id;
      if (this.classList.contains('jsc-qv-var-wrap')) {
        var forceComingSoon = false;
        var isVipVariant = false;
        $('.side-panel-inner .product-information--inner .variant-list-data').each(function () {
          if ($(this).attr('data-var-id') == currentvarID) {
            if ($(this).attr('showcomingsoonwheninstock') == 'true') {
              forceComingSoon = true;
            }
            if ($(this).attr('data-vip') == 'true') {
              isVipVariant = true;
            }
          }
        });
        var isVipCustomer = $("#vipCustomer").length >= 1;
        var shouldDisableForVip = isVipVariant && !isVipCustomer;
        var $qvContainer = $('.side-panel-inner .product-information--inner');
        var $qvButton = $qvContainer.find('.single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)');
        var $qvBuyNow = $qvContainer.find('.jsc-buy-it-now-button:not(.bundle-atc)');
        if (forceComingSoon === true) {
          $qvButton.hide();
          $qvContainer.find('.single-add-to-cart-button-coming-soon').remove();
          var qvLaunchDate = $('.side-panel-inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
          var qvNewText = (qvLaunchDate && qvLaunchDate !== '') ? qvLaunchDate : 'Coming Soon';
          var $qvNewDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + qvNewText + '</span></div>');
          $qvButton.after($qvNewDiv);
          $qvContainer.addClass('jsc-hide-payment-button');
          $qvBuyNow.hide().attr('disabled', 'disabled').addClass('jsc-sold-out-styling');
        } else if (shouldDisableForVip) {
          $qvButton.hide();
          $qvContainer.find('.single-add-to-cart-button-coming-soon').remove();
          var qvVipLaunchDate = $('.side-panel-inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
          var qvVipNewText = (qvVipLaunchDate && qvVipLaunchDate !== '') ? qvVipLaunchDate : 'Coming Soon';
          var $qvVipNewDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling vip_atc"><span class="single-add-to-cart-button--text">' + qvVipNewText + '</span></div>');
          $qvButton.after($qvVipNewDiv);
          $qvContainer.addClass('jsc-hide-payment-button');
          $qvBuyNow.hide().attr('disabled', 'disabled').addClass('jsc-sold-out-styling');
        } else {
          $qvContainer.find('.single-add-to-cart-button-coming-soon').remove();
          $qvButton.show();
          $qvContainer.removeClass('jsc-hide-payment-button');
          if (this.currentVariant.available) {
            $qvButton.removeClass('sold-out jsc-sold-out-styling vip_atc').removeAttr('disabled');
            $qvButton.find('.single-add-to-cart-button--text').text('Add To Bag');
            $qvBuyNow.show().removeClass('jsc-sold-out-styling').removeAttr('disabled');
          } else {
            $qvButton.addClass('jsc-sold-out-styling').attr('disabled', 'disabled');
            $qvButton.find('.single-add-to-cart-button--text').text(window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut ? window.theme.variantStrings.soldOut : 'Sold Out');
            $qvBuyNow.addClass('jsc-sold-out-styling').attr('disabled', 'disabled');
          }
        }
      }
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      this.updateVariantAddToCartState();

      // Run add-to-cart/coming-soon update immediately (next tick) so UI updates before fetch completes
      const self = this;
      setTimeout(function () { self.updateVariantAddToCartState(); }, 0);

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.updateVariantAddToCartState();
        });
    }

    updateVariantAddToCartState() {
          if (!this.currentVariant) return;
          var currentvarAvai = this.currentVariant.available;
          var currentvarID = this.currentVariant.id;
          var forceComingSoon = false;
          // var forceDataLaunchDateTime = '';
          var isVipVariant = false;
          // var vipLaunchDateTime = '';
          var currentVariantThis = this;
          // First pass: collect variant data. In QV use only side-panel data; on PDP/grid use grid.
          if (currentVariantThis.classList.contains('jsc-qv-var-wrap')) {
            $('.side-panel-inner .product-information--inner .variant-list-data').each(function () {
              if ($(this).attr('data-var-id') == currentvarID) {
                if ($(this).attr('showcomingsoonwheninstock') == 'true') {
                  forceComingSoon = true;
                }
                if ($(this).attr('data-vip') == 'true') {
                  isVipVariant = true;
                }
              }
            });
          } else {
            $('.product-grid-container .product-information--inner .variant-list-data').each(function () {
              if ($(this).attr('data-var-id') == currentvarID) {
                if ($(this).attr('showcomingsoonwheninstock') == 'true') {
                  forceComingSoon = true;
                }
                if ($(this).attr('data-vip') == 'true') {
                  isVipVariant = true;
                }
              }
            });
          }
            
            // Check if VIP variant but user is NOT VIP - should disable button
            var isVipCustomer = $("#vipCustomer").length >= 1;
            var shouldDisableForVip = isVipVariant && !isVipCustomer;
            
            if (currentVariantThis.classList.contains('jsc-qv-var-wrap') == false) {
              if(forceComingSoon == true){
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                //Add to bag and direct to cart page button
                $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                // Hide original button and create new div element
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').hide();
                // Remove any existing coming soon div
                $('.product-grid-container .product-information--inner .single-add-to-cart-button-coming-soon').remove();
                var forceDataLaunchDateTime = $('.product-grid-container .product-information--inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
                var newText = (forceDataLaunchDateTime && forceDataLaunchDateTime != '') ? forceDataLaunchDateTime : 'Coming Soon';
                var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').after($newDiv);
              }else if(shouldDisableForVip){
                // VIP variant but user is not VIP - disable button
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').addClass('vip_atc');
                //Add to bag and direct to cart page button
                $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                // Hide original button and create new div element
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').hide();
                // Remove any existing coming soon div
                $('.product-grid-container .product-information--inner .single-add-to-cart-button-coming-soon').remove();
                var vipLaunchDateTime = $('.product-grid-container .product-information--inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
                var newText = (vipLaunchDateTime && vipLaunchDateTime != '') ? vipLaunchDateTime : 'Coming Soon';
                var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling vip_atc"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').after($newDiv);
              }else{
                // Remove coming soon div and show original button when not coming soon
                $('.product-grid-container .product-information--inner .single-add-to-cart-button-coming-soon').remove();
                currentVariantThis.toggleAddButton(!currentVariantThis.currentVariant.available, window.theme.variantStrings.soldOut);
                if (currentVariantThis.currentVariant.available && forceComingSoon != true) {
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').show();
                  $('.product-grid-container .product-information--inner .shopify-payment-button:not(.bundle-atc)').show();
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeAttr('disabled');
                  $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('vip_atc');
                  //Add to bag and direct to cart page button
                  $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').show();
                  $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').removeAttr('disabled');
                  $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                  if ($('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text').length > 0) {
                    $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text').text('Add To Bag');
                  }else{
                    $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').text('Add To Bag');
                  }
                }else{
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                  //Add to bag and direct to cart page button
                  $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                  $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                }
              }
  
              setTimeout(function () {
                $('.product-grid-container .product-information--inner').each(function () {
                  var thisprodInfo = $(this);
                  var $mainProductOnly = function(sel) { return thisprodInfo.find(sel).filter(function() { return $(this).closest('.jsc-pwp-pdp-section').length === 0; }); };
                  var vipVar = false;
                  var bishide = false;
                  var forcecomingsoon = false;
                  var showcomingsoonwheninstock = 'false';
                  thisprodInfo.find(".variant-list-data").each(function () {
                    var datavarid = $(this).attr('data-var-id');
                    var datavip = $(this).attr('data-vip');
                    // var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                    if (datavarid == currentvarID) {
                      showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
                    }
                    if (datavarid == currentvarID && showcomingsoonwheninstock == 'true') {
                      forcecomingsoon = true;
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      //Add to bag and direct to cart page button
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      // Hide original button and create new div element
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").hide();
                      // Remove any existing coming soon div
                      thisprodInfo.find(".single-add-to-cart-button-coming-soon").remove();
                      var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                      var newText = (dataLaunchDateTime != '' && dataLaunchDateTime) ? dataLaunchDateTime : 'Coming Soon';
                      var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").after($newDiv);
                      if($(this).attr('showcomingsoonwheninstock') == 'true'){
                        showcomingsoonwheninstock = 'true';
                      }else{
                        showcomingsoonwheninstock = 'false';
                      }
                    }else{
                      //check each if the variant is VIP if VIP check whether VIP customer is login.
                      if (datavarid == currentvarID && datavip) {
                        if (datavip == 'true') {
                          vipVar = true;
                          if ($("#vipCustomer").length >= 1 && currentvarAvai) {
                            // Remove coming soon div and show original button
                            thisprodInfo.find(".single-add-to-cart-button-coming-soon").remove();
                            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
                            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
                            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                            //Add to bag and direct to cart page button
                            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
                            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                            if ($mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").length > 0) {
                            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text('Add To Bag');
                            }else{
                              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").text('Add To Bag');
                            }
                          }else{
                            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            //Add to bag and direct to cart page button
                            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                            if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                              // if(dataLaunchDateTime){
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
                              // }else{
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
                              // }
                            }else{
                              // if(dataLaunchDateTime){
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text(dataLaunchDateTime);
                              // }else{
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('Coming Soon');
                              // }
                            }
                          }
                        }
                      }
                      //Hide/Show PWP Section
                      var dataPWP = $(this).attr('data-pwp-show');
                      if (datavarid == currentvarID) {
                        if (dataPWP == 'true') {
                          $("#jsc-pwp-section").show();
                        }else{
                          $("#jsc-pwp-section").hide();
                        }
                      }
      
                      var databishide = $(this).attr('data-bis-hide');
                      if (datavarid == currentvarID) {
                        if (databishide == 'true') {
                          bishide = true;
                        }
                      }
                      if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
                        bishide = true;
                      }
                    }
                  });
                  if (vipVar == false && !shouldDisableForVip) {
                    $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
                    console.log(currentvarAvai);
                    if (currentvarAvai == false) {
                      $mainProductOnly('.product-form__input--color input[type="radio"]:checked').addClass('is-disabled');
                      thisprodInfo.find(".swym-bid-pdp").show();
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").hide();
                      //Add to bag and direct to cart page button
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
                      if (bishide) {
                        console.log('bishide');
                        thisprodInfo.find(".swym-bid-pdp").hide();
                        $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
                        thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
                        //Add to bag and direct to cart page button
                        $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                      }else if (showcomingsoonwheninstock == 'true'){
                        console.log('showcomingsoonwheninstock',showcomingsoonwheninstock);
                        thisprodInfo.find(".swym-bid-pdp").hide();
                        $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
                        thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
                        //Add to bag and direct to cart page button
                        $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                      }
                      if (forcecomingsoon) {
                        console.log('forcecomingsoon');
                        thisprodInfo.find(".swym-bid-pdp").hide();
                        $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
                        //For add to cart sticky
                        $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
                        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                        //Add to bag and direct to cart page button
                        $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                      }
                    }else{
                      thisprodInfo.find(".swym-bid-pdp").hide();
                      enablePWPATC();
                    }
                  }else{
                    $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
                    thisprodInfo.find(".swym-bid-pdp").hide();
                    enablePWPATC();
                  }
    
                  $('.var-limit-list').each(function(){
                    var varID = $(this).val();
                    if (varID == currentvarID) {
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text('You’ve Hit The Max!');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
                      //Add to bag and direct to cart page button
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    }
                  });
    
                  $('.var-limit-product-list').each(function(){
                    var varID = $(this).val();
                    if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text('You’ve Hit The Max!');
                      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
                      //Add to bag and direct to cart page button
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    }
                  });
    
                });
              }, 0);
            }else{
              // Quick view (side panel): apply coming soon/launch date or normal add to bag
              var $qvContainer = $('.side-panel-inner .product-information--inner');
              var $qvButton = $qvContainer.find('.single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)');
              var $qvBuyNow = $qvContainer.find('.jsc-buy-it-now-button:not(.bundle-atc)');
              if (forceComingSoon === true) {
                $qvButton.hide();
                $qvContainer.find('.single-add-to-cart-button-coming-soon').remove();
                var qvLaunchDate = $('.side-panel-inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
                var qvNewText = (qvLaunchDate && qvLaunchDate !== '') ? qvLaunchDate : 'Coming Soon';
                var $qvNewDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + qvNewText + '</span></div>');
                $qvButton.after($qvNewDiv);
                $qvContainer.addClass('jsc-hide-payment-button');
                $qvBuyNow.hide().attr('disabled', 'disabled').addClass('jsc-sold-out-styling');
              } else if (shouldDisableForVip) {
                $qvButton.hide();
                $qvContainer.find('.single-add-to-cart-button-coming-soon').remove();
                var qvVipLaunchDate = $('.side-panel-inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
                var qvVipNewText = (qvVipLaunchDate && qvVipLaunchDate !== '') ? qvVipLaunchDate : 'Coming Soon';
                var $qvVipNewDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling vip_atc"><span class="single-add-to-cart-button--text">' + qvVipNewText + '</span></div>');
                $qvButton.after($qvVipNewDiv);
                $qvContainer.addClass('jsc-hide-payment-button');
                $qvBuyNow.hide().attr('disabled', 'disabled').addClass('jsc-sold-out-styling');
              } else {
                $qvContainer.find('.single-add-to-cart-button-coming-soon').remove();
                $qvButton.show();
                $qvContainer.removeClass('jsc-hide-payment-button');
                if (currentVariantThis.currentVariant.available) {
                  $qvButton.removeClass('sold-out jsc-sold-out-styling vip_atc').removeAttr('disabled');
                  $qvButton.find('.single-add-to-cart-button--text').text('Add To Bag');
                  $qvBuyNow.show().removeClass('jsc-sold-out-styling').removeAttr('disabled');
                } else {
                  $qvButton.addClass('jsc-sold-out-styling').attr('disabled', 'disabled');
                  $qvButton.find('.single-add-to-cart-button--text').text(currentVariantThis.currentVariant ? (window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut) || 'Sold Out' : 'Sold Out');
                  $qvBuyNow.addClass('jsc-sold-out-styling').attr('disabled', 'disabled');
                }
              }
              if ($('.swym-bid-pdp').is(":visible")) {
              }else{
                // Only enable if NOT a VIP variant that should be disabled
                if(!shouldDisableForVip){
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').show();
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                  $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                  if ($('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text').length > 0) {
                    $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text').text('Add To Bag');
                  }else{
                    $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').text('Add To Bag');
                  }
                  $('.product-grid-container .product-information--inner .single-add-to-cart-button:not(.bundle-atc)').removeAttr('disabled');
                  //Add to bag and direct to cart page button
                  $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                  $('.product-grid-container .product-information--inner .jsc-buy-it-now-button:not(.bundle-atc)').removeAttr('disabled');
                }
                $('.product-grid-container .product-information--inner').each(function () {
                  var thisprodInfo = $(this);
                  var vipVar = false;
                  var showcomingsoonwheninstock = 'false';
                  thisprodInfo.find(".variant-list-data").each(function () {
                    var datavarid = $(this).attr('data-var-id');
                    var datavip = $(this).attr('data-vip');
                    // var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                    if (datavarid == currentvarID) {
                      showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
                    }
                    if (datavarid == currentvarID && showcomingsoonwheninstock == 'true') {
                      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      //Add to bag and direct to cart page button
                      thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      // Hide original button and create new div element
                      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").hide();
                      // Remove any existing coming soon div
                      thisprodInfo.find(".single-add-to-cart-button-coming-soon").remove();
                      var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                      var newText = (dataLaunchDateTime != '' && dataLaunchDateTime) ? dataLaunchDateTime : 'Coming Soon';
                      var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").after($newDiv);
                      if($(this).attr('showcomingsoonwheninstock') == 'true'){
                        showcomingsoonwheninstock = 'true';
                      }else{
                        showcomingsoonwheninstock = 'false';
                      }
                    }else{
                      //check each if the variant is VIP if VIP check whether VIP customer is login.
                      if (datavarid == currentvarID && datavip) {
                        if (datavip == 'true') {
                          vipVar = true;
                          if ($("#vipCustomer").length >= 1 && currentvarAvai) {
                            // Remove coming soon div and show original button
                            thisprodInfo.find(".single-add-to-cart-button-coming-soon").remove();
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                            if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
                            }else{
                              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('Add To Bag');
                            }
                            //Add to bag and direct to cart page button
                            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
                            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                          }else{
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            //Add to bag and direct to cart page button
                            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                            if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                              // if(dataLaunchDateTime){
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
                              // }else{
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
                              // }
                            }else{
                              // if(dataLaunchDateTime){
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text(dataLaunchDateTime);
                              // }else{
                              //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('Coming Soon');
                              // }
                            }
                          }
                        }
                      }
                    }
                  });
                });
              }
              setTimeout(function () {
              $('.side-panel-inner .product-information--inner').each(function () {
                var thisprodInfo = $(this);
                var $mainProductOnly = function(sel) { return thisprodInfo.find(sel).filter(function() { return $(this).closest('.jsc-pwp-pdp-section').length === 0; }); };
                var vipVar = false;
                var bishide = false;
                var showcomingsoonwheninstock = 'false';
                thisprodInfo.find(".variant-list-data").each(function () {
                  var datavarid = $(this).attr('data-var-id');
                  var datavip = $(this).attr('data-vip');
                  // var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                  if (datavarid == currentvarID) {
                    showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
                  }
                  if (datavarid == currentvarID && showcomingsoonwheninstock == 'true') {
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                    //Add to bag and direct to cart page button
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    // Hide original button and create new div element
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").hide();
                    // Remove any existing coming soon div
                    thisprodInfo.find(".single-add-to-cart-button-coming-soon").remove();
                    var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                    var newText = (dataLaunchDateTime != '' && dataLaunchDateTime) ? dataLaunchDateTime : 'Coming Soon';
                    var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").after($newDiv);
                    if($(this).attr('showcomingsoonwheninstock') == 'true'){
                      showcomingsoonwheninstock = 'true';
                    }else{
                      showcomingsoonwheninstock = 'false';
                    }
                  }else{
                    //check each if the variant is VIP if VIP check whether VIP customer is login.
                    if (datavarid == currentvarID && datavip) {
                      if (datavip == 'true') {
                        vipVar = true;
                        if ($("#vipCustomer").length >= 1 && currentvarAvai) {
                          // Remove coming soon div and show original button
                          thisprodInfo.find(".single-add-to-cart-button-coming-soon").remove();
                          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
                          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
                          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                          $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                          if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
                          }else{
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('Add To Bag');
                          }
                          //Add to bag and direct to cart page button
                          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
                          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                        }else{
                          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                          if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                            // if(dataLaunchDateTime){
                            //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
                            // }else{
                            //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
                            // }
                          }else{
                            // if(dataLaunchDateTime){
                            //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text(dataLaunchDateTime);
                            // }else{
                            //   thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('Coming Soon');
                            // }
                          }
                          //Add to bag and direct to cart page button
                          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                        }
                      }
                    }

                    var databishide = $(this).attr('data-bis-hide');
                    if (datavarid == currentvarID) {
                      if (databishide == 'true') {
                        bishide = true;
                      }
                    }
                    if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
                      bishide = true;
                    }
                  }
                });
                thisprodInfo.find(".swym-bid-qv").attr('data-variant-id', currentvarID);
                if (vipVar == false && !shouldDisableForVip) {
                  thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
                  if (currentvarAvai == false) {
                    $mainProductOnly('.product-form__input--color input[type="radio"]:checked').addClass('is-disabled');
                    thisprodInfo.find(".swym-bid-qv").show();
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hide();
                    //Add to bag and direct to cart page button
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
                    if (bishide) {
                      thisprodInfo.find(".swym-bid-qv").hide();
                      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
                      //Add to bag and direct to cart page button
                      thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                    }else if (showcomingsoonwheninstock == 'true'){
                      thisprodInfo.find(".swym-bid-qv").hide();
                      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
                      //Add to bag and direct to cart page button
                      thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                    }
                  }else{
                    thisprodInfo.find(".swym-bid-qv").hide();
                    enablePWPATC();
                  }
                }else{
                  thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
                  thisprodInfo.find(".swym-bid-qv").hide();
                  enablePWPATC();
                }
  
                $('.var-limit-list').each(function(){
                  var varID = $(this).val();
                  if (varID == currentvarID) {
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
                    //Add to bag and direct to cart page button
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                  }
                });
                $('.var-limit-product-list').each(function(){
                  var varID = $(this).val();
                  if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
                    //Add to bag and direct to cart page button
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                  }
                });
                
              });
              if ($('.swym-bid-pdp').is(":visible")) {
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
              }
              }, 0);
            }
          

            if (currentVariantThis.classList.contains('jsc-qv-var-wrap') == false) {
              if(forceComingSoon == true){
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                //Add to bag and direct to cart page button
                $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                // Hide original button and create new div element
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)').hide();
                // Remove any existing coming soon div
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button-coming-soon').remove();
                var forceDataLaunchDateTime = $('.product-grid-container .product-information--inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
                var newText = (forceDataLaunchDateTime && forceDataLaunchDateTime != '') ? forceDataLaunchDateTime : 'Coming Soon';
                var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)').after($newDiv);
              }else if(shouldDisableForVip){
                // VIP variant but user is not VIP - disable button for sticky ATC
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').addClass('vip_atc');
                //Add to bag and direct to cart page button
                $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').attr('disabled', 'disabled');
                $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                // Hide original button and create new div element
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)').hide();
                // Remove any existing coming soon div
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button-coming-soon').remove();
                var vipLaunchDateTime = $('.product-grid-container .product-information--inner .variant-list-data[data-var-id="' + currentvarID + '"]').attr('data-launch-time-date');
                var newText = (vipLaunchDateTime && vipLaunchDateTime != '') ? vipLaunchDateTime : 'Coming Soon';
                var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling vip_atc"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)').after($newDiv);
              }else{
                // Remove coming soon div and show original button when not coming soon
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button-coming-soon').remove();
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').show();
                $('.product-add-to-cart-sticky--content .shopify-payment-button:not(.bundle-atc)').show();
                //Add to bag and direct to cart page button
                $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').show();
                if (currentVariantThis.currentVariant.available) {
                  $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                  $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeAttr('disabled');
                  $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                  $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                  $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('vip_atc');
                  if ($('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text').length > 0) {
                    $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text').text('Add To Bag');
                  }else{
                    $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').text('Add To Bag');
                  }
                  //Add to bag and direct to cart page button
                  $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeAttr('disabled');
                  $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                }else{
                  $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                  $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                  //Add to bag and direct to cart page button
                  $('.product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                }
              }
              setTimeout(function () {
                var productInformationInner = $('.product-add-to-cart-sticky--content').closest('.product-information').find('.product-information--inner');
                console.log("productInformationInner", productInformationInner);
                $(productInformationInner).each(function () {
                  var thisprodInfo = $(this);
                  var vipVar = false;
                  var bishide = false;
                  var showcomingsoonwheninstock = 'false';
                  thisprodInfo.find(".variant-list-data").each(function () {
                    var datavarid = $(this).attr('data-var-id');
                    var datavip = $(this).attr('data-vip');
                    // var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                    if (datavarid == currentvarID) {
                      showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
                    }
                    if (datavarid == currentvarID && showcomingsoonwheninstock == 'true') {
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      // Hide original button and create new div element
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").hide();
                      // Remove any existing coming soon div
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button-coming-soon").remove();
                      var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                      var newText = (dataLaunchDateTime != '' && dataLaunchDateTime) ? dataLaunchDateTime : 'Coming Soon';
                      var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").after($newDiv);
                      if($(this).attr('showcomingsoonwheninstock') == 'true'){
                        showcomingsoonwheninstock = 'true';
                      }else{
                        showcomingsoonwheninstock = 'false';
                      }
                    }else{
                      //check each if the variant is VIP if VIP check whether VIP customer is login.
                      if (datavarid == currentvarID && datavip) {
                        console.log("datavip", datavip);
                        if (datavip == 'true') {
                          vipVar = true;
                          if ($("#vipCustomer").length >= 1 && currentvarAvai) {
                            // Remove coming soon div and show original button
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button-coming-soon").remove();
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                            //Add to bag and direct to cart page button
                            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
                            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                            if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
                            }else{
                              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('Add To Bag');
                            }
                          }else{
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                            //Add to bag and direct to cart page button
                            $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            if ($('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                              // if(dataLaunchDateTime){
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
                              // }else{
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
                              // }
                            }else{
                              // if(dataLaunchDateTime){
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text(dataLaunchDateTime);
                              // }else{
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('Coming Soon');
                              // }
                            }
                          }
                        }
                      }
                      
                      //Hide/Show PWP Section
                      var dataPWP = $(this).attr('data-pwp-show');
                      if (datavarid == currentvarID) {
                        if (dataPWP == 'true') {
                          $("#jsc-pwp-section").show();
                        }else{
                          $("#jsc-pwp-section").hide();
                        }
                      }
      
                      var databishide = $(this).attr('data-bis-hide');
                      if (datavarid == currentvarID) {
                        if (databishide == 'true') {
                          bishide = true;
                        }
                      }
                      if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
                        bishide = true;
                      }
                    }

                  });
                  if (vipVar == false && !shouldDisableForVip) {
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
                    if (currentvarAvai == false) {
                      $('.product-add-to-cart-sticky--content').find('.product-form__input--color input[type="radio"]:checked').filter(function() { return $(this).closest('.jsc-pwp-pdp-section').length === 0; }).addClass('is-disabled');
                      $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").show();
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").hide();
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
                      if (bishide) {
                        $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
                        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                        $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
                        //Add to bag and direct to cart page button
                        $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                      }else if (showcomingsoonwheninstock == 'true'){
                        $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
                        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                        $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").hide();
                        //Add to bag and direct to cart page button
                        $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
                      }
                    }else{
                      $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
                      enablePWPATC();

                    }
                  }else{
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc abc9');
                    $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
                    enablePWPATC();
                  }
    
                  $('.var-limit-list').each(function(){
                    var varID = $(this).val();
                    if (varID == currentvarID) {
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    }
                  });
    
                  $('.var-limit-product-list').each(function(){
                    var varID = $(this).val();
                    if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    }
                  });
    
                });
              }, 0);
            }else{
              $('product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').show();
              $('product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
              $('product-add-to-cart-sticky--content .product-add-to-cart-container').removeClass('jsc-hide-payment-button');
              //Add to bag and direct to cart page button
              $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').show();
              $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
              if (currentVariantThis.currentVariant.available) {
                $('product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                $('product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                //Add to bag and direct to cart page button
                $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
              }else{
                $('product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                //Add to bag and direct to cart page button
                $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').addClass('jsc-sold-out-styling');
              }
              if ($('.swym-bid-pdp').is(":visible")) {
              }else{
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').show();
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('sold-out');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').text('Add To Bag');
                $('.product-add-to-cart-sticky--content .single-add-to-cart-button:not(.bundle-atc)').removeAttr('disabled');
                //Add to bag and direct to cart page button
                $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeClass('jsc-sold-out-styling');
                $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').removeAttr('disabled');
                $('product-add-to-cart-sticky--content .jsc-buy-it-now-button:not(.bundle-atc)').show();
                $('.product-add-to-cart-sticky--content').each(function () {
                  var thisprodInfo = $(this);
                  var vipVar = false;
                  var showcomingsoonwheninstock = 'false';
                  thisprodInfo.find(".variant-list-data").each(function () {
                    var datavarid = $(this).attr('data-var-id');
                    var datavip = $(this).attr('data-vip');
                    // var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                    if (datavarid == currentvarID) {
                      showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
                    }
                    if (datavarid == currentvarID && showcomingsoonwheninstock == 'true') {
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                      // Hide original button and create new div element
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").hide();
                      // Remove any existing coming soon div
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button-coming-soon").remove();
                      var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                      var newText = (dataLaunchDateTime != '' && dataLaunchDateTime) ? dataLaunchDateTime : 'Coming Soon';
                      var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").after($newDiv);
                      if($(this).attr('showcomingsoonwheninstock') == 'true'){
                        showcomingsoonwheninstock = 'true';
                      }else{
                        showcomingsoonwheninstock = 'false';
                      }
                    }else{
                      //check each if the variant is VIP if VIP check whether VIP customer is login.
                      if (datavarid == currentvarID && datavip) {
                        if (datavip == 'true') {
                          vipVar = true;
                          if ($("#vipCustomer").length >= 1 && currentvarAvai) {
                            // Remove coming soon div and show original button
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button-coming-soon").remove();
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                            if ($('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
                            }else{
                              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('Add To Bag');
                            }
                            //Add to bag and direct to cart page button
                            $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
                            $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                          }else{
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                            //Add to bag and direct to cart page button
                            $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                            $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                            if ($('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                              // if(dataLaunchDateTime){
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
                              // }else{
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
                              // }
                            }else{
                              // if(dataLaunchDateTime){
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text(dataLaunchDateTime);
                              // }else{
                              //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('Coming Soon');
                              // }
                            }
                          }
                        }
                      }
                    }
                  });
                });
              }
              setTimeout(function () {
              var productInformationInner = $('.product-add-to-cart-sticky--content').closest('.product-information').find('.product-information--inner');
              console.log("productInformationInner", productInformationInner);
              $(productInformationInner).each(function () {
                var thisprodInfo = $(this);
                var vipVar = false;
                var bishide = false;
                var showcomingsoonwheninstock = 'false';
                thisprodInfo.find(".variant-list-data").each(function () {
                  var datavarid = $(this).attr('data-var-id');
                  var datavip = $(this).attr('data-vip');
                  // var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                  if (datavarid == currentvarID) {
                    showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
                  }
                  if (datavarid == currentvarID && showcomingsoonwheninstock == 'true') {
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                    //Add to bag and direct to cart page button
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    // Hide original button and create new div element
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").hide();
                    // Remove any existing coming soon div
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button-coming-soon").remove();
                    var dataLaunchDateTime = $(this).attr('data-launch-time-date');
                    var newText = (dataLaunchDateTime != '' && dataLaunchDateTime) ? dataLaunchDateTime : 'Coming Soon';
                    var $newDiv = $('<div class="single-add-to-cart-button single-add-to-cart-button-coming-soon jsc-coming-soon-placeholder jsc-sold-out-styling"><span class="single-add-to-cart-button--text">' + newText + '</span></div>');
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc):not(.single-add-to-cart-button-coming-soon)").after($newDiv);
                    if($(this).attr('showcomingsoonwheninstock') == 'true'){
                      showcomingsoonwheninstock = 'true';
                    }else{
                      showcomingsoonwheninstock = 'false';
                    }
                  }else{
                    //check each if the variant is VIP if VIP check whether VIP customer is login.
                    if (datavarid == currentvarID && datavip) {
                      if (datavip == 'true') {
                        vipVar = true;
                        if ($("#vipCustomer").length >= 1 && currentvarAvai) {
                          // Remove coming soon div and show original button
                          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button-coming-soon").remove();
                          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
                          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                          $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
                          if ($('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
                          }else{
                            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('Add To Bag');
                          }
                          //Add to bag and direct to cart page button
                          $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
                          $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
                        }else{
                          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                          //Add to bag and direct to cart page button
                          $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                          $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                          if ($('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
                            // if(dataLaunchDateTime){
                            //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
                            // }else{
                            //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
                            // }
                          }else{
                            // if(dataLaunchDateTime){
                            //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text(dataLaunchDateTime);
                            // }else{
                            //   $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('Coming Soon');
                            // }
                          }
                        }
                      }
                    }

                    var databishide = $(this).attr('data-bis-hide');
                    if (datavarid == currentvarID) {
                      if (databishide == 'true') {
                        bishide = true;
                      }
                    }
                    if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
                      bishide = true;
                    }
                  }
                });
                thisprodInfo.find(".swym-bid-qv").attr('data-variant-id', currentvarID);
                if (vipVar == false && !shouldDisableForVip) {
                  $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
                  if (currentvarAvai == false) {
                    $('.product-add-to-cart-sticky--content').find('.product-form__input--color input[type="radio"]:checked').filter(function() { return $(this).closest('.jsc-pwp-pdp-section').length === 0; }).addClass('is-disabled');
                    $('.product-add-to-cart-sticky--content').find(".swym-bid-qv").show();
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").hide();
                    //Add to bag and direct to cart page button
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
                    if (bishide) {
                      $('.product-add-to-cart-sticky--content').find(".swym-bid-qv").hide();
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                    }else if (showcomingsoonwheninstock){
                      $('.product-add-to-cart-sticky--content').find(".swym-bid-qv").hide();
                      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
                      //Add to bag and direct to cart page button
                      $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
                    }
                  }else{
                    $('.product-add-to-cart-sticky--content').find(".swym-bid-qv").hide();
                    enablePWPATC();
                  }
                }else{
                  $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc abc10');
                  $('.product-add-to-cart-sticky--content').find(".swym-bid-qv").hide();
                  enablePWPATC();
                }

                $('.var-limit-list').each(function(){
                  var varID = $(this).val();
                  if (varID == currentvarID) {
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
                    //Add to bag and direct to cart page button
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                  }
                });
                $('.var-limit-product-list').each(function(){
                  var varID = $(this).val();
                  if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
                    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
                    //Add to bag and direct to cart page button
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
                    $('.product-add-to-cart-sticky--content').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
                  }
                });
                
              });
              if ($('.swym-bid-pdp').is(":visible")) {
                $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
              }
              }, 0);
            }
            if (typeof window.jscApplyPreorderUI === 'function' && currentvarID) {
              var $preorderScope = currentVariantThis.classList.contains('jsc-qv-var-wrap')
                ? $('.side-panel-inner .product-information--inner')
                : $('.product-grid-container .product-information--inner');
              window.jscApplyPreorderUI(currentvarID, $preorderScope);
              setTimeout(function () {
                window.jscApplyPreorderUI(currentvarID, $preorderScope);
              }, 10);
            }
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button, .jsc-buy-it-now-button');
      if (!submitButtons) return;

      const variantId = this.currentVariant && this.currentVariant.id;
      const availableLabel = (variantId && typeof window.jscGetAtcLabel === 'function')
        ? window.jscGetAtcLabel(variantId)
        : (window.theme && window.theme.variantStrings && window.theme.variantStrings.addToCart) || 'Add To Bag';

      submitButtons.forEach((submitButton) => {
        const isBuyItNow = submitButton.classList.contains('jsc-buy-it-now-button');
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (!isBuyItNow && submitButtonText && text) {
            submitButtonText.textContent = text;
          }
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          if (!isBuyItNow && submitButtonText) {
            submitButtonText.textContent = availableLabel;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              // Match by option value (not DOM index). Color categories
              // (Classic/Seasonal) regroup radios so index order diverges
              // from variant option order and incorrectly crosses out stock.
              fieldset.querySelectorAll('input').forEach((input) => {
                const option = fieldset_options.find((opt) => opt.value === input.value);
                if (option) {
                  input.classList.toggle('is-disabled', option.isUnavailable);
                }
              });
            }
          }
        });

        // if ($('.pdp-section').find('input[name="Size"]').length == $('.pdp-section').find('input[name="Size"].is-disabled').length) {
        //   console.log('all sold out size');
        // }else{
        //   if ($('.pdp-section').find('input[name="Size"]').length > 0) {
        //     console.log('some sold out size');
        //     $('.pdp-section').find('input[name="Colour"]').removeClass('is-disabled');
        //   }
        // }

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      this.redirectOnAdd = false;
      this.isSubmitting = false;
      this.boundClickHandler = this.handleFormClick.bind(this);
      this.boundSubmitHandler = this.onSubmitHandler.bind(this);
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    connectedCallback() {
      if (this.form && !this.listenersAttached) {
        // Ensure PWP product buttons are not disabled on initialization
        // They should remain enabled so users can click and see error messages
        // Form submission will be prevented by validation instead
        const pwpButtons = this.form.querySelectorAll('.jsc-pwp-product');
        pwpButtons.forEach(button => {
          // Only re-enable if it's not disabled for valid reasons (sold out, VIP, etc.)
          // PWP buttons should be clickable - validation will prevent submission when needed
          if (button.hasAttribute('disabled') && 
              !button.classList.contains('sold-out') && 
              !button.classList.contains('vip_atc')) {
            // Re-enable the button - we'll prevent submission via validation instead
            button.removeAttribute('disabled');
          }
        });
        
        // Only the main (non-sticky) product-form attaches to the form; sticky shares the same form
        // and would duplicate submit/click handlers, causing add-to-cart to run twice
        if (!this.sticky) {
          this.form.addEventListener('click', this.boundClickHandler);
          this.form.addEventListener('submit', this.boundSubmitHandler);
        }
        
        // For sticky forms, intercept button clicks to prevent direct form submission via inline onclick
        if (this.sticky) {
          const buttons = this.form.querySelectorAll('button[type="submit"], .single-add-to-cart-button, .go-to-cart-btn');
          buttons.forEach(button => {
            // Remove inline onclick handlers that directly submit the form
            const originalOnclick = button.getAttribute('onclick');
            if (originalOnclick && originalOnclick.includes('submit()')) {
              button.removeAttribute('onclick');
              button.onclick = null;
              
              // Store original onclick functions (like pintrk, updateOverlay) for later use
              const onclickParts = originalOnclick.split(';');
              const nonSubmitParts = onclickParts.filter(part => !part.includes('submit()')).join(';');
              if (nonSubmitParts.trim()) {
                button.dataset.originalOnclick = nonSubmitParts.trim();
              }
              
              // Add click listener that prevents default and triggers form submit event
              // This ensures our submit handler (with validation) runs
              button.addEventListener('click', (e) => {
                // Execute non-submit parts of original onclick (like pintrk, updateOverlay)
                if (button.dataset.originalOnclick) {
                  try {
                    // Create a function from the stored onclick code
                    const onclickFunc = new Function(button.dataset.originalOnclick);
                    onclickFunc.call(button);
                  } catch (err) {
                    console.log('Error executing original onclick:', err);
                  }
                }
                
                // Prevent the direct form.submit() call
                e.preventDefault();
                e.stopPropagation();
                
                // Trigger form submit event which will run our validation
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                this.form.dispatchEvent(submitEvent);
              }, true); // Use capture phase to intercept before any other handlers
            }
          });
        }
        this.listenersAttached = true;
      }
    }

    disconnectedCallback() {
      if (this.form && this.listenersAttached && !this.sticky) {
        this.form.removeEventListener('click', this.boundClickHandler);
        this.form.removeEventListener('submit', this.boundSubmitHandler);
        this.listenersAttached = false;
      } else if (this.form && this.listenersAttached && this.sticky) {
        this.listenersAttached = false;
      }
    }

    handleFormClick(e) {
      const clickedButton = e.target?.closest?.('button');
      if (clickedButton && this.form.contains(clickedButton)) {
        this.redirectOnAdd = clickedButton.classList.contains('go-to-cart-btn');
        if (clickedButton.type === 'submit' && this.isSubmitting) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        
        // For sticky forms, intercept submit button clicks to run validation
        if (this.sticky && clickedButton.type === 'submit') {
          // Check if this is a PWP product and validate before submitting
          const pwpProductId = this.form.dataset.pwpProductId;
          const pwpCollectionId = this.form.dataset.pwpCollectionId;
          const pwpMinQty = this.form.dataset.pwpMinQty ? parseInt(this.form.dataset.pwpMinQty, 10) : null;
          const currentProductId = this.form.querySelector('[data-prod-id]')?.dataset.prodId;
          
          if (pwpProductId && pwpCollectionId && pwpMinQty && currentProductId) {
            const isPWPProduct = currentProductId === pwpProductId;
            
            if (isPWPProduct) {
              // Prevent default submission
              e.preventDefault();
              e.stopPropagation();
              
              // Manually trigger the submit handler which will run validation
              const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
              this.form.dispatchEvent(submitEvent);
              return false;
            }
          }
        }
      }
    }

    onSubmitHandler(evt) {
      if (this.isSubmitting) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }
      
      var functionrunATC = true;
      masterpromorunThemeATC = true;
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }

      var selectedVarForLimit = $('.pdp-section').find('.variant-selected-form').val() || this.form.querySelector('[name="id"]')?.value;
      if ($(this).hasClass('product-form-qv')) {
        selectedVarForLimit = $('.side-panel').find('.variant-selected-form').val() || selectedVarForLimit;
      }
      var $vdLimit = $(this).find('.variant-list-data[data-var-id="' + selectedVarForLimit + '"]').first();
      if (!$vdLimit.length) {
        $vdLimit = $('.variant-list-data[data-var-id="' + selectedVarForLimit + '"]').first();
      }
      if (typeof window.jscIsPreorderOverLimitFromEl === 'function' && window.jscIsPreorderOverLimitFromEl($vdLimit)) {
        var $limitNotice = $(this).find('.jsc-preorder-limit-notice');
        if (!$limitNotice.length) $limitNotice = $('.jsc-preorder-limit-notice');
        $limitNotice.show();
        if (typeof window.jscApplyPreorderUI === 'function') {
          window.jscApplyPreorderUI(selectedVarForLimit, $(this));
        }
        return false;
      }
      
      // Check PWP product limits before submitting
      const isPWPProduct = this.form.querySelector('.jsc-pwp-product');
      
      if (isPWPProduct) {
        // Check if limit is reached
        const limitReached = document.querySelector('.jsc-pwp-limit-new');
        if (limitReached) {
          // Show error message
          const limitReachMsg = this.form.querySelector('.limit-reach') || 
                                this.form.closest('.product-information--inner, .product-add-to-cart-container')?.querySelector('.limit-reach') ||
                                document.querySelector('.limit-reach');
          
          if (limitReachMsg) {
            limitReachMsg.style.display = 'block';
            setTimeout(() => {
              limitReachMsg.style.display = 'none';
            }, 2500);
          }
          
          // Prevent submission
          return false;
        }
        
        // Check if minimum quantity is not met
        const minQtyNotMet = document.querySelector('.jsc-pwp-min-qty-not-met');
        if (minQtyNotMet) {
          // Show error message
          const minQtyMsg = this.form.querySelector('.min-reach-not-met') || 
                           this.form.closest('.product-information--inner, .product-add-to-cart-container')?.querySelector('.min-reach-not-met') ||
                           document.querySelector('.min-reach-not-met');
          
          if (minQtyMsg) {
            minQtyMsg.style.display = 'block';
            setTimeout(() => {
              minQtyMsg.style.display = 'none';
            }, 2500);
          }
          
          // Prevent submission
          return false;
        }
      }
      
      this.isSubmitting = true;

      var qvatc = false;
      var selectedvarID = $('.pdp-section').find('.variant-selected-form').val();
      if ($(this).hasClass('product-form-qv')) {
        qvatc = true;
        selectedvarID = $('.side-panel').find('.variant-selected-form').val();
      }
      var thisform = this;
      var addtocart = true;

      $(this).find('.variant-list-data').each(function(){
        var varID = $(this).val();
        if (varID == selectedvarID) {
          var salevar = $(this).attr('data-sale-var');
          if (salevar) {
            if ($('#tvccustomer').length > 0) {
              console.log('tvccustomer');
            }else{
              addtocart = true; //this is suppose to be false
              return;
            }
          }
        }
      });

      const allAddToCartButtons = this.form.querySelectorAll('.single-add-to-cart-button, .go-to-cart-btn');
      
      allAddToCartButtons.forEach((button) => {
        if (!button.classList.contains('loading')) {
          button.setAttribute('aria-disabled', true);
          
          if (button.classList.contains('go-to-cart-btn')) {
            if (this.redirectOnAdd) {
              button.classList.add('loading');
            }
            button.setAttribute('aria-disabled', true);
          } else {
            if (!this.redirectOnAdd) {
              button.classList.add('loading');
              button.classList.add('jsc-item-added');
              button.textContent = 'Item Added';
            }
            // Always disable it
            button.setAttribute('aria-disabled', true);
          }
        }
      });
      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      if (addtocart) {
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          // If user clicked the special button, redirect to cart page instead of opening drawer
          if (this.redirectOnAdd) {
            window.location.href = theme.routes.cart_url;
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });

          //added by jumpstart
          if (masterpromorunThemeATC == functionrunATC) {
            masterPromo();
            earlyaccesslimit();
          }
          masterpromorunThemeATC = false;
          functionrunATC = false;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // Reset submission flag
          this.isSubmitting = false;
          // Reset all add-to-cart buttons
          if (this.redirectOnAdd) {
          }else{
            allAddToCartButtons.forEach((button) => {
              button.removeAttribute('aria-disabled');
              
              // Restore correct button text based on button type
              if (button.classList.contains('go-to-cart-btn')) {
                button.textContent = 'Buy It Now';
              } else {
                button.classList.remove('loading', 'jsc-item-added');
                button.textContent = 'Add To Bag';
              }
            });
          }
        });
      }else{
        // Reset submission flag
        this.isSubmitting = false;
        $(thisform).find('.product-form__error-message-wrapper').removeAttr('hidden');
        $(thisform).find('.product-form__error-message').text('Log in to your Vine Club account to add to bag!');
        
        // Reset all add-to-cart buttons
        allAddToCartButtons.forEach((button) => {
          button.classList.remove('loading', 'jsc-item-added');
          button.removeAttribute('aria-disabled');
          
          // Restore correct button text based on button type
          if (button.classList.contains('go-to-cart-btn')) {
            button.textContent = 'Buy It Now';
          } else {
            button.classList.remove('loading', 'jsc-item-added');
            button.textContent = 'Add To Bag';
          }
        });
      }
    }

    //Add by jumpstart
    updateFreeShipping() {
      console.log('updateFreeShipping3');
      const free_shipping = document.getElementById('Cart-Drawer')?.querySelector('.free-shipping');
      
      if (free_shipping) {
        // Scope selectors to this specific element
        const shippingLine = free_shipping.querySelector('.jsc-shipping-line');
        const spendShippingLine = free_shipping.querySelector('.jsc-spend-shipping-line');
        
        // Initially hide both
        if (shippingLine) shippingLine.style.display = 'none';
        if (spendShippingLine) spendShippingLine.style.display = 'none';
        
        // Fetch current cart data to get accurate total
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('Product - Cart data fetched:', cart.total_price);
            // Update the data-cart-total attribute with current cart total
            free_shipping.dataset.cartTotal = cart.total_price;
            
            let amount_text = free_shipping.querySelector('.free-shipping--text .jsc-remaining-amount');
            // Use cart total from API instead of DOM attribute
            let total = cart.total_price || parseInt(free_shipping.dataset.cartTotal, 10);
            let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10));
            let percentage = 1;

            var storeSG = false;
            var storeJP = false;
            var storePH = false;

            if (location.href.includes('.com')) {
              storeSG = true;
            } else if(location.href.includes('.jp')){
              storeJP = true;
            }else if(location.href.includes('.ph')){
              storePH = true;
            }

            // Use URL-based detection for local countries (bypasses IP API rate limit)
            var isLocalCountry = storeSG || storeJP || storePH;
            
            if (isLocalCountry) {
              // Local country - use local minimum, no IP API call needed
              console.log('Product - Local country (URL-based) - total:', total, 'minimum:', minimum);
              
              // Set shipping text for local country
              var frontShippingTextLocal = 'FREE shipping will be applied at checkout.';
              var backShippingTextLocal = document.getElementById('jsc-back-shipping-text-local') ? document.getElementById('jsc-back-shipping-text-local').value.trim() : '';
              if (shippingLine) shippingLine.textContent = frontShippingTextLocal;
              if (spendShippingLine) spendShippingLine.textContent = backShippingTextLocal;
              
              if (total < minimum) {
                percentage = total / minimum;
                if (amount_text) {
                  let remaining = minimum - total,
                    format = window.theme.settings.money_with_currency_format || "${{amount}}";
                  amount_text.innerHTML = formatMoney(remaining, format);
                }
                getUserIPInfo();
                if (shippingLine) shippingLine.style.display = 'none';
                if (spendShippingLine) spendShippingLine.style.display = '';
                console.log('Product - Showing spend shipping line');
              }else{
                if (spendShippingLine) spendShippingLine.style.display = 'none';
                if (shippingLine) shippingLine.style.display = '';
                console.log('Product - Showing free shipping line');
              }
              free_shipping.style.setProperty('--percentage', percentage);
              console.log('Product - Percentage:', percentage);
            } else {
              // International - only call IP API to check if user is from MY
              var cachedIPInfo = sessionStorage.getItem('jsc_ipinfo_country');
              
              if (cachedIPInfo) {
                var userIPCountry = cachedIPInfo;
                console.log('Product - Using cached IP country:', userIPCountry);
                processInternationalShipping(userIPCountry);
              } else {
                $.get("https://ipinfo.io/json", function (response) {
                  var userIPCountry = response.country;
                  sessionStorage.setItem('jsc_ipinfo_country', userIPCountry);
                  console.log('Product - Fetched IP country:', userIPCountry);
                  processInternationalShipping(userIPCountry);
                }, "jsonp").fail(function() {
                  console.log('Product - IP API failed, using default international minimum');
                  processInternationalShipping(null);
                });
              }
            }
            
            function processInternationalShipping(userIPCountry) {
              var intlMinimum = minimum;
              if(userIPCountry == "MY"){
                intlMinimum = Math.round(parseInt(free_shipping.dataset.minMy, 10));
              }else{
                intlMinimum = Math.round(parseInt(free_shipping.dataset.minimumInt, 10));
              }
              
              // Set shipping text for international
              var frontShippingTextInt = 'FREE shipping will be applied at checkout.';
              var backShippingTextInt = document.getElementById('jsc-back-shipping-text-int') ? document.getElementById('jsc-back-shipping-text-int').value.trim() : '';
              if (shippingLine) shippingLine.textContent = frontShippingTextInt;
              if (spendShippingLine) spendShippingLine.textContent = backShippingTextInt;
              
              if (total < intlMinimum) {
                percentage = total / intlMinimum;
                if (amount_text) {
                  let remaining = intlMinimum - total,
                    format = window.theme.settings.money_with_currency_format || "${{amount}}";
                  amount_text.innerHTML = formatMoney(remaining, format);
                }
                getUserIPInfo();
                if (shippingLine) shippingLine.style.display = 'none';
                if (spendShippingLine) spendShippingLine.style.display = '';
                console.log('Product - Showing spend shipping line (intl)');
              }else{
                if (spendShippingLine) spendShippingLine.style.display = 'none';
                if (shippingLine) shippingLine.style.display = '';
                console.log('Product - Showing free shipping line (intl)');
              }
              free_shipping.style.setProperty('--percentage', percentage);
              console.log('Product - Percentage:', percentage);
            }
        })
        .catch(error => {
          console.log("Error fetching cart data:", error);
          // Fallback to DOM attribute if API fails
          const shippingLine = free_shipping.querySelector('.jsc-shipping-line');
          const spendShippingLine = free_shipping.querySelector('.jsc-spend-shipping-line');
          
          let amount_text = free_shipping.querySelector('.free-shipping--text .jsc-remaining-amount');
          let total = parseInt(free_shipping.dataset.cartTotal, 10);
          let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10));
          let percentage = 1;

          var storeSG = false;
          var storeJP = false;
          var storePH = false;

          if (location.href.includes('.com')) {
            storeSG = true;
          } else if(location.href.includes('.jp')){
            storeJP = true;
          }else if(location.href.includes('.ph')){
            storePH = true;
          }

          var isLocalCountry = storeSG || storeJP || storePH;
          
          if (isLocalCountry) {
            // Local country - use local minimum
            // Set shipping text for local country
            var frontShippingTextLocal = 'FREE shipping will be applied at checkout.';
            var backShippingTextLocal = document.getElementById('jsc-back-shipping-text-local') ? document.getElementById('jsc-back-shipping-text-local').value.trim() : '';
            if (shippingLine) shippingLine.textContent = frontShippingTextLocal;
            if (spendShippingLine) spendShippingLine.textContent = backShippingTextLocal;
            
            if (total < minimum) {
              percentage = total / minimum;
              if (amount_text) {
                let remaining = minimum - total,
                  format = window.theme.settings.money_with_currency_format || "${{amount}}";
                amount_text.innerHTML = formatMoney(remaining, format);
              }
              getUserIPInfo();
              if (shippingLine) shippingLine.style.display = 'none';
              if (spendShippingLine) spendShippingLine.style.display = '';
            }else{
              if (spendShippingLine) spendShippingLine.style.display = 'none';
              if (shippingLine) shippingLine.style.display = '';
            }
            free_shipping.style.setProperty('--percentage', percentage);
          } else {
            // International - try cached or use default
            var cachedIPInfo = sessionStorage.getItem('jsc_ipinfo_country');
            var userIPCountry = cachedIPInfo || null;
            var intlMinimum = minimum;
            
            // Set shipping text for international
            var frontShippingTextInt = 'FREE shipping will be applied at checkout.';
            var backShippingTextInt = document.getElementById('jsc-back-shipping-text-int') ? document.getElementById('jsc-back-shipping-text-int').value.trim() : '';
            if (shippingLine) shippingLine.textContent = frontShippingTextInt;
            if (spendShippingLine) spendShippingLine.textContent = backShippingTextInt;
            
            if(userIPCountry == "MY"){
              intlMinimum = Math.round(parseInt(free_shipping.dataset.minMy, 10));
            }else{
              intlMinimum = Math.round(parseInt(free_shipping.dataset.minimumInt, 10));
            }
            
            if (total < intlMinimum) {
              percentage = total / intlMinimum;
              if (amount_text) {
                let remaining = intlMinimum - total,
                  format = window.theme.settings.money_with_currency_format || "${{amount}}";
                amount_text.innerHTML = formatMoney(remaining, format);
              }
              getUserIPInfo();
              if (shippingLine) shippingLine.style.display = 'none';
              if (spendShippingLine) spendShippingLine.style.display = '';
            }else{
              if (spendShippingLine) spendShippingLine.style.display = 'none';
              if (shippingLine) shippingLine.style.display = '';
            }
            free_shipping.style.setProperty('--percentage', percentage);
          }
        });
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-item-icon' //Add by jumpstart
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            const cartDrawer = document.getElementById('Cart-Drawer');
            const productRecommendations = cartDrawer?.querySelector('.product-recommendations--full');
            if (productRecommendations && productRecommendations.classList) {
                productRecommendations.classList.add('active');
            }
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              const cartDrawer = document.getElementById('Cart-Drawer');
              const productRecommendations = cartDrawer?.querySelector('.product-recommendations--full');
              if (productRecommendations && productRecommendations.classList) {
                  productRecommendations.classList.add('active');
              }
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
      this.updateFreeShipping();
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Add by jumpstart
function changeScrollTopBtnPosition(position) {
  var backToTopElement = document.querySelector('.back-to-top');
  if (backToTopElement) {
    backToTopElement.style.bottom = position;
  }
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
                //add by jumpstart
                changeScrollTopBtnPosition('20px');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
                //add by jumpstart
                changeScrollTopBtnPosition('110px');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
                //add by jumpstart
                changeScrollTopBtnPosition('110px');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
                //add by jumpstart
                changeScrollTopBtnPosition('20px');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}